<svelte:options
  customElement={{
    tag: "cta-button",
    shadow: "none"//Svelteコンポーネントが普通のHTML要素と同じように扱われ、ページ単位で読み込んでいるstyles.scss がそのまま適用される
  }}
/>

<script>
  import { onMount } from 'svelte';
  import gsap from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';
  gsap.registerPlugin(ScrollTrigger);

  import AppDownloadModal from "@ce/AppDownloadModal.svelte"
  const appIcon = "/assets_default/icons/app_icon.svg"
  const CTA = "/assets_default/images/common/cta_app.webp"
  let {
    ctaSize = 'large',
    ctaURL = 'https://minna-no-ginko.go.link/bwUec',
    ctaTitle = '最短5分で口座開設、<br>すぐに使える<sup>※1</sup>',
    getItNow = 'true',
    ctaAnnotation = 'true',
    annotationCaption = 'false',
    annotationCaptiontype = ''
  } = $props();

  let buttonSizeClass = $derived(ctaSize === 'small' ? 'small' : 'large');
  let sendIDSizeVariable = $derived("common-footer-cta-app")
  let buttonStyleClass = $derived(ctaSize === 'medium' ? 'secondary:white' : 'primary');
  let annotationClass = $derived(ctaAnnotation === 'true' ? (ctaSize === 'medium' ? 'spacing:bottom:18' : 'spacing:bottom:64') : '');

  let ctaImageContainer = $state();

  $effect(() => {
    if (ctaSize === 'large' && ctaImageContainer) {
      const image = ctaImageContainer.querySelector('img');

      gsap.set(ctaImageContainer, { perspective: 800 });

      gsap.set(image, {
        y: 150,
        scale: 0.9,
      });

      gsap.to(image, {
        y: 0,
        scale: 1,
        scrollTrigger: {
          trigger: ctaImageContainer,
          start: 'top 90%',
          end: 'top 0%',
          scrub: 2,
        }
      });
    }

    if (ctaSize === 'medium') {
      sendIDSizeVariable = "common-black-cta-app"
    } else if (ctaSize === 'small') {
      sendIDSizeVariable = "common-gray-cta-app"
    }
  });
</script>

{#if getItNow === "true"}
<p class="owd-cta-copy spacing:bottom:48">GET IT<br>NOW</p>
{/if}
<div class="owd-cta owd-cta:{ctaSize} {annotationClass}">
  <div class="owd-cta:labelarea {ctaSize === "small" ? 'spacing:bottom:16' : 'spacing:bottom:24' }">
    <img src={appIcon} alt="アプリアイコン">
    <p class="{ctaSize === "small" ? 'owd-text:04' : 'owd-text:05' }"><strong>{@html ctaTitle}</strong></p>
  </div>
  {#if ctaSize === "large"}
  <p class="owd-text:02 align:center spacing:bottom:16">まずはみんなの銀行アプリをダウンロード、<br>口座開設から始めよう</p>
  <div class="owd-cta:image spacing:bottom:12" bind:this={ctaImageContainer}>
    <img src={CTA} alt="アプリ画面" >
  </div>
  {/if}
  <a href="{ctaURL}" id={sendIDSizeVariable} class="owd-button owd-button:{buttonSizeClass} owd-button:{buttonStyleClass}">今すぐアプリをダウンロード</a>
</div>

{#if ctaAnnotation === "true"}
<div class="owd-cta-annotation">
  {#if annotationCaption === "true"}
    {#if annotationCaptiontype.length > 0}
    <p class="owd-caption spacing:bottom:12">{@html annotationCaptiontype}</p>
   {:else if annotationCaption === "loan"}
    <p class="owd-caption spacing:bottom:12">みんなの銀行のローン（カードなしのカードローン）はローンの申込みから借入れ、返済までかんたんにスマートフォンアプリ上で完結できます。マイカーの購入や資格取得のためなど、使途自由で、利用限度額は最大1,000万円。年金利は安心の1.5%～14.5%で申込みできます。申込みはお勤め先情報・年収の入力のみ、一度契約するといつでも好きなときに借入れ・返済可能です。口座開設からATM入出金、振込、デビットカード、ローンの利用まですべてスマートフォンで完結できる、みんなの銀行を使ってみませんか？</p>
    {:else if annotationCaption === "atm"}
    <p class="owd-caption spacing:bottom:12">みんなの銀行なら、銀行ATMの入出金もスマホアプリで完結！ 日本全国の商業施設や空港、駅などに設置されている「セブン銀行ATM」でいつでも利用できます。キャッシュカード不要（なし）で現金の引出し、預入れができるからもっと便利でスマートに。スマホだけあれば、急に現金が必要になっても大丈夫です。そして、お得なキャンペーンも実施中！ みんなの銀行を使ってみませんか？</p>
    {:else if annotationCaption === "box"}
    <p class="owd-caption spacing:bottom:12">みんなの銀行 ボックスは、アプリ内で使いみちや目的ごとにお金を仕分けて整理・整頓できる機能です。例えば、旅行用に預金（貯蓄）をしたり生活費や家賃のためにお金をよけておいたりとかんたんにお金を管理できます。自動振替設定をすれば自動化もできます。振替スケジュールは毎日・毎週・毎月・毎年から選べて振替金額は1円から設定も可能です。この機会にお金の管理や預金（貯蓄）にも便利なみんなの銀行で口座開設してみませんか？</p>
    {:else if annotationCaption === "cover"}
    <p class="owd-caption spacing:bottom:12">みんなの銀行のカバーは、事前に契約しておくことで、もしあなたの預金残高がゼロになっても自動的に無利子で最大5万円まで立て替えてくれるサービス（プレミアムサービスの無料オプション）です。カバーは後払いサービスのように利用でき、返済方法も超シンプル。ATMやアプリからでもかんたんに返済できるので、安心して利用できます。そして、お得なキャンペーンも実施中！みんなの銀行を使ってみませんか？</p>
    {:else}
    <p class="owd-caption spacing:bottom:12">みんなの銀行はスマートフォン完結で24時間365日、いつでも銀行の口座開設ができます。みんなの銀行ではeKYC（オンライン本人確認） を導入しているため、書類の郵送は一切不要で即日口座が開設できるのもメリット。そして、お得なキャンペーンやプログラムも開催中です！ この機会に日本初となるデジタルバンク「みんなの銀行」を使ってみませんか？</p>
    {/if}
  {/if}
  <ul class="owd-list:annotation:number">
    <li><span class="owd-list:annotation:number-text" data-annotation-number="1">マイナンバーカード読み取り＆パスワード認証で口座開設を行った場合</span></li>
    <li><span class="owd-list:annotation:number-text">メルカリ支店は、みんなの銀行アプリから口座開設はできません。メルカリアプリからのみ開設可能な支店です。</span></li>
    <li><span class="owd-list:annotation:number-text">掲載しているアプリ画面は開発中のものにつき、実際の仕様とは異なる場合があります。</span></li>
    <li class="show:pc"><span class="owd-list:annotation:number-text">「QRコード」は株式会社デンソーウェーブの登録商標です。</span></li>
  </ul>
</div>
{/if}

<AppDownloadModal {appIcon} {CTA}/>

<style lang="scss">
// @use '../../style/styles';
.owd-cta{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  &-copy{
    text-align: center;
  }
  &\:labelarea{
    display: flex;
    align-items: center;
    gap: 16px;
    img{
      width: 80px;
    }
  }
  &\:image{
    max-width: 294px;
  }
  &\:small{
    padding: 32px 24px;
    background-color: var(--light-gray);
    .owd-cta{
      &\:labelarea{
        img{
          width: 60px;
        }
      }
    }
    .owd-button{
      max-width: 252px;
    }
  }
  &\:medium{
    padding: 48px 24px;
    background-color: var(--primary-black);
    .owd-cta{
      &\:labelarea{
        p{
          color: var(--primary-white);
        }
      }
    }
  }
  &-annotation{
    >p{
      opacity: .7;
    }
  }
}
</style>
